import billingModule from '../../billing.module';

class BillingSubscriptionService {
    constructor($q, billingSubscriptionApiService) {
        this.$q = $q;
        this.billingSubscriptionApiService = billingSubscriptionApiService;

        this.promiseCache = {};
    }

    getSubscriptions() {
        return this.billingSubscriptionApiService.getSubscriptions();
    }

    getCurrentSubscription() {
        var promiseId = 'getCurrentSubscription';

        if (this.promiseCache[promiseId]) {
            return this.promiseCache[promiseId].promise;
        }

        var deferred = this.$q.defer();
        this.promiseCache[promiseId] = deferred;

        this.getSubscriptions()
            .then(data => {
                if (!data.items) {
                    deferred.reject(data);
                    return;
                }

                deferred.resolve(data.items[0]);
            }, deferred.reject)
            .finally(() => delete this.promiseCache[promiseId]);

        return deferred.promise;
    }
}

export default billingModule.service(
    'billingSubscriptionService',
    BillingSubscriptionService
);



// WEBPACK FOOTER //
// ./modules/billing/services/subscription/billingSubscription.service.js